module.exports = __webpack_public_path__ + "img/img(6).699ff610.png";